export const locales = ['en', 'au', 'uk', 'us'];
